import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-gatorz-grid-item';
const html = `
<div class="container-gatorz">
  <div class="wrap-card">
    <div data-attribute="card-title" data-show="true" class="card-title">
      <h2 style="text-align: center">Available Features</h2>
    </div>
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19a656d44914ab0d474c.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>GHOST TEMPLE</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19ab899528af96be1918.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>DURABLE ALUMINUM FRAME w/ LIFETIME WARRANTY</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19af688bdaa8d6a310b9.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>MILSPEC BALLISTIC</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19b58efbaea70d20827c.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>ANTI-FOG COATING</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19b8651486a6ef5a7531.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>VISIBILITY OF DIGITAL SCREENS</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19bcec3d94825828a276.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>POLARIZED GLARE REDUCTION</p>
        </div>
      </div>

      <div data-attribute="item" class="item">
        <div class="wrap-icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a19c4544b190ddf08a0bb.webp"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="wrap-content">
          <p>CERAKOTE FINISH</p>
        </div>
      </div>
    </div>
    <div data-attribute="text-note" data-show="true" class="text-note">
      <p>*Collection offers these features; please check individual frame specs once product is selected.</p>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#d8d8d8',
});
